module.exports = __webpack_public_path__ + "img/logo.8e4633ec.png";